import { getSearchHistory } from './get';
import { queryCleaner } from './utils/queryCleaner';

export const findInSearchHistory = (
  query: string,
  history?: string[], // Without this param the history is get from local storage
): boolean => {
  const searchQuery = queryCleaner(query);

  if (searchQuery) {
    let currentHistory = history;

    if (!currentHistory) {
      currentHistory = getSearchHistory();
    }

    const isInHistory = currentHistory
      .map((entry) => queryCleaner(entry))
      .includes(searchQuery);
    return isInHistory;
  }

  return false;
};
